import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { components, ImageCardComponent, ImageCardTitleComponent } from './components';
import { pipes } from './pipes';
import { modals } from './modals';
import { directives } from './directives';
import { pages } from './pages';
import { ReactiveFormsModule } from '@angular/forms';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { YouTubePlayerModule } from '@angular/youtube-player';
import {
  GptLocalizationModule,
  GptLocalNumberPipe,
  GptLocalStringNumberPipe,
} from '@geneplanet/ngx-utils/src/lib/localization';
import { GptRouterBackModule } from '@geneplanet/ngx-utils/src/lib/router-back';
import { AnalyticsModule } from '@geneplanet/ngx-utils';
import { GpuCheckboxModule } from '@geneplanet/ngx-ui/src/lib/checkbox';
import { GpuCollapseModule } from '@geneplanet/ngx-ui/src/lib/collapse';
import { GpuFormFieldModule } from '@geneplanet/ngx-ui/src/lib/form-field';
import { GpuLayoutModule } from '@geneplanet/ngx-ui/src/lib/layout';
import { GpuLoadingModule } from '@geneplanet/ngx-ui/src/lib/loading';
import { GpuRadioGroupModule } from '@geneplanet/ngx-ui/src/lib/radio-group';
import { GpuToastModule } from '@geneplanet/ngx-ui/src/lib/toast';
import { GpuCarouselModule } from '@geneplanet/ngx-ui/src/lib/carousel';
import { ScrollOnFocusDirective } from './directives/scroll-on-focus.directive';
import { FormPageFooterComponent } from './components/form-page-footer/form-page-footer.component';
import { AnalysisHeaderComponent } from './components/analysis-header/analysis-header.component';
import { AnalysisHeaderTitleComponent } from './components/analysis-header/components/title/title.component';
import { LokaliseTranslatePipe } from '../lokalise';
import { AnalysisHeaderButtonComponent } from './components/analysis-header/components/button/button.component';
import { ImageHeaderComponent } from './components/image-header/image-header.component';

const standaloneComponents = [
  FormPageFooterComponent,
  AnalysisHeaderComponent,
  AnalysisHeaderTitleComponent,
  AnalysisHeaderButtonComponent,
  ImageCardComponent,
  ImageCardTitleComponent,
  ImageHeaderComponent,
];

@NgModule({
  imports: [
    TranslateModule,
    RouterModule,
    CommonModule,
    ReactiveFormsModule,
    NgbModule,
    InlineSVGModule,
    YouTubePlayerModule,
    GpuCarouselModule,
    GpuCollapseModule,
    GpuFormFieldModule,
    GpuCheckboxModule,
    GpuRadioGroupModule,
    GpuLoadingModule,
    GpuLayoutModule,
    GpuToastModule,
    GptLocalizationModule,
    GptRouterBackModule,
    AnalyticsModule,
    ScrollOnFocusDirective,
    ...standaloneComponents,
    LokaliseTranslatePipe
  ],
  declarations: [...components, ...pipes, ...modals, ...directives, ...pages],
  exports: [
    ...components,
    ...standaloneComponents,
    ...pipes,
    ...modals,
    ...directives,
    ...pages,
    AnalyticsModule,
    ScrollOnFocusDirective,
  ],
  providers: [...pipes, GptLocalStringNumberPipe, GptLocalNumberPipe],
})
export class SharedModule {}
